import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  poNumber: {
    type: "text", //required
    name: "poNumber", //required
    label: "PO No", //required
    errorMsg: "PO No is required", //optional
    required: true, //optional
    maxLength: 20, //optional
    //tabIndex: 1,
    editable: false, //optional (used for edit)
  },
  poDate: {
    type: "date",
    name: "poDate",
    label: "PO Date",
    errorMsg: "PO Date is required",
    required: true,
  },
  poType: { type: "select", name: "poType", label: "PO Type", maxLength: 1, required: true },
  sellerRef: { type: "text", name: "sellerRef", label: "Seller Ref", maxLength: 20 },
  buyerRef: { type: "text", name: "buyerRef", label: "Buyer Ref", maxLength: 20 },
  vendorCode: {
    type: "select",
    name: "vendorCode",
    label: "Vendor Code",
    errorMsg: "Vendor Code is required",
    required: true,
    editable: false,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
  },
  sellerCompany: { type: "text", name: "sellerCompany", label: "Company", maxLength: 100 },
  sellerAddress1: { type: "text", name: "sellerAddress1", label: "Address1", maxLength: 200 },
  sellerAddress2: { type: "text", name: "sellerAddress2", label: "Address2", maxLength: 200 },
  sellerPostcode: { type: "text", name: "sellerPostcode", label: "Postcode", maxLength: 10 },
  sellerCity: { type: "text", name: "sellerCity", label: "City", maxLength: 100 },
  sellerState: { type: "text", name: "sellerState", label: "State", maxLength: 100 },
  sellerCountry: { type: "select", name: "sellerCountry", label: "Country", maxLength: 100 },
  sellerPhoneNo: { type: "text", name: "sellerPhoneNo", label: "Tel No", maxLength: 20 },
  sellerFaxNo: { type: "text", name: "sellerFaxNo", label: "Fax No", maxLength: 20 },
  remark: { type: "text", name: "remark", label: "Remark", maxLength: 300 },
  status: { type: "text", name: "status", label: "Status", disabled: true },
};

const {
  poNumber,
  poDate,
  poType,
  sellerRef,
  buyerRef,
  vendorCode,
  customerCode,
  sellerCompany,
  sellerAddress1,
  sellerAddress2,
  sellerPostcode,
  sellerCity,
  sellerState,
  sellerCountry,
  sellerPhoneNo,
  sellerFaxNo,
  remark,
  status,
} = formField;

// export const headerRender = [
//   [poNumber, status],
//   [poDate, poType],
//   [sellerRef, buyerRef],
//   [
//     {
//       //if u want to wrap field
//       type: "fieldset",
//       label: "Vendor",
//       fieldsetRender: [
//         [vendorCode, customerCode],
//         [sellerCompany],
//         [sellerAddress1],
//         [sellerAddress2],
//         [sellerPostcode, sellerCity],
//         [sellerState, sellerCountry],
//         [sellerPhoneNo, sellerFaxNo],
//       ],
//     },
//   ],
//   [remark],
// ];
export const headerRender = [
  [poNumber, poDate, poType, status],
  [sellerRef, buyerRef, remark],
  [
    {
      //if u want to wrap field
      type: "fieldset",
      label: "Vendor",
      fieldsetRender: [
        [vendorCode, sellerCompany,customerCode],
        [sellerAddress1, sellerAddress2, sellerPostcode, sellerCity],
        [sellerState, sellerCountry, sellerPhoneNo, sellerFaxNo],
      ],
    },
  ],
  //[remark],
];
export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [poNumber.name]: Yup.string().nullable().max(poNumber.maxLength).required(poNumber.errorMsg),
  //[poDate.name]: Yup.string().nullable().required(poDate.errorMsg),
  [poDate.name]: Yup.string().nullable().required(poDate.errorMsg),
  [poType.name]: Yup.object()
    .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
    .nullable()
    .required(poType.errorMsg),
  [vendorCode.name]: Yup.string().nullable().required(vendorCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [sellerRef.name]: Yup.string().nullable().max(sellerRef.maxLength),
  [buyerRef.name]: Yup.string().nullable().max(buyerRef.maxLength),
  [sellerCompany.name]: Yup.string().nullable().max(sellerCompany.maxLength),
  [sellerAddress1.name]: Yup.string().nullable().max(sellerAddress1.maxLength),
  [sellerAddress2.name]: Yup.string().nullable().max(sellerAddress2.maxLength),
  [sellerPostcode.name]: Yup.string().nullable().max(sellerPostcode.maxLength),
  [sellerState.name]: Yup.string().nullable().max(sellerState.maxLength),
  [sellerCity.name]: Yup.string().nullable().max(sellerCity.maxLength),
  [sellerCountry.name]: Yup.string().nullable().max(sellerCountry.maxLength),
  [sellerPhoneNo.name]: Yup.string().nullable().max(sellerPhoneNo.maxLength),
  [sellerFaxNo.name]: Yup.string().nullable().max(sellerFaxNo.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
});
